import { useClientContext } from '@/context/client'
import { useClientForm } from '../hooks/use-client-form'
import ClientRegimeFormPF from './client-regime-form-pf'
import { ClientRegimeFormData, ClientRegimeFormDataCpf } from '@/types/client'

export function ClientRegistrationFlowPf() {
  const {
    clientMode,
    mostrarCampos,
    clienteData,
    contadorData,
    bancos,
    regimeTributario,
    produtosSelecionados,
    customComissao,
    comissaoEscrita,
    bancoData,
    concordo,
    isClienteCriado,
    isMinutaEnviada,
    setShowEditarPopup,
    setShowAssinarPopup
  } = useClientContext()

  const { createStatusClient, handleRegimeFormSubmit, handleRegimeFormSubmitCPF, handleAssinarContrato } = useClientForm()

  if (!mostrarCampos || !clientMode) return null

  const handleAssinarContratoADistancia = () => {
    setShowAssinarPopup(true)
  }

  const handlePfSubmit = async (formData: ClientRegimeFormData | ClientRegimeFormDataCpf) => {
    if (clientMode === 'existing-owner') {
      await handleRegimeFormSubmitCPF(formData as ClientRegimeFormDataCpf)
      return
    }

    await handleRegimeFormSubmit(formData as ClientRegimeFormData)
  }

  return (
    <ClientRegimeFormPF
      requiresPassword={clientMode !== 'existing-owner'}
      clientData={clienteData}
      contadorData={contadorData}
      bancos={bancos}
      initialData={{
        regimeTributario,
        produtosSelecionados,
        comissao: customComissao,
        comissaoEscrita,
        banco: bancoData.banco,
        agencia: bancoData.agencia,
        conta: bancoData.conta,
        concordo
      }}
      onSubmit={handlePfSubmit}
      isClienteCriado={isClienteCriado}
      isMinutaEnviada={isMinutaEnviada}
      createStatusClient={createStatusClient}
      onEditClick={() => setShowEditarPopup(true)}
      onAssinarContrato={handleAssinarContrato}
      onAssinarContratoADistancia={handleAssinarContratoADistancia}
    />
  )
}
